import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

import {
	TMavenirDataModelType,
	TMavenirDescriptorType,
	TMavenirDeviceType,
	TMavenirElementType,
	TMavenirGroupBy,
	TMavenirPnfType,
} from '@enums/configurationDataModelManagement';

import { TSelectOption } from '../components/componentTypes';

export const EConfigurationDataFieldNames = {
	NAME: 'name',
	DESCRIPTOR_TYPE: 'descriptorType',
	DATA_MODEL_TYPE: 'dataModelType',
	DEVICE_TYPE: 'deviceType',
	VDU_ID: 'vduId',
	DATA_MODEL: 'dataModel',
	PNF_TYPE: 'pnfType',
	BUILD_VERSION: 'buildVersion',
	ELEMENT_TYPE: 'elementType',
	GROUP_BY: 'groupBy',
	PRODUCT_NAME: 'productName',
	NS_ID: 'nsId',
	NS_VERSION: 'nsVersion',
	NF_TYPE: 'nfType',
	COMPONENT_TYPE: 'componentType',
	COMPONENT_VERSION: 'componentVersion',
} as const;

export const EOranConfigurationDataFieldNames = {
	NAME: 'name',
} as const;

export const EConfigurationDataFolderFieldNames = {
	PRESET_NAME: 'presetName',
} as const;

export type TConfigurationDataFieldNames = TValueOfStringRecord<typeof EConfigurationDataFieldNames>

export type TOranConfigurationDataFieldNames = TValueOfStringRecord<typeof EOranConfigurationDataFieldNames>

export interface IConfigurationDataFormValues {
	[EConfigurationDataFieldNames.NAME]: TSelectOption<string>;
	[EConfigurationDataFieldNames.DESCRIPTOR_TYPE]: TSelectOption<string | TMavenirDescriptorType>;
	[EConfigurationDataFieldNames.DATA_MODEL_TYPE]: TSelectOption<string | TMavenirDataModelType>;
	[EConfigurationDataFieldNames.DEVICE_TYPE]: TSelectOption<string | TMavenirDeviceType>;
	[EConfigurationDataFieldNames.VDU_ID]?: TSelectOption<string>;
	[EConfigurationDataFieldNames.DATA_MODEL]?: string;
	[EConfigurationDataFieldNames.PNF_TYPE]?: TSelectOption<string | TMavenirPnfType>;
	[EConfigurationDataFieldNames.BUILD_VERSION]?: TSelectOption<string>;
	[EConfigurationDataFieldNames.ELEMENT_TYPE]?: TSelectOption<string | TMavenirElementType>;
	[EConfigurationDataFieldNames.GROUP_BY]?: TSelectOption<string | TMavenirGroupBy>;
	[EConfigurationDataFieldNames.PRODUCT_NAME]?: TSelectOption<string>;
	[EConfigurationDataFieldNames.NS_ID]?: TSelectOption<string>;
	[EConfigurationDataFieldNames.NS_VERSION]?: TSelectOption<string>;
	[EConfigurationDataFieldNames.NF_TYPE]?: TSelectOption<string>;
	[EConfigurationDataFieldNames.COMPONENT_TYPE]?: TSelectOption<string>;
	[EConfigurationDataFieldNames.COMPONENT_VERSION]?: TSelectOption<string>;
}

export interface IOranConfigurationDataFormValues {
	[EOranConfigurationDataFieldNames.NAME]: TSelectOption<string>;
}

export interface IConfigurationDataAnalysisValues {
	[EConfigurationDataFieldNames.NAME]: string;
	[EConfigurationDataFieldNames.DESCRIPTOR_TYPE]: TMavenirDescriptorType | string;
	[EConfigurationDataFieldNames.DATA_MODEL_TYPE]: TMavenirDataModelType | string;
	[EConfigurationDataFieldNames.DEVICE_TYPE]: TMavenirDeviceType | string;
	[EConfigurationDataFieldNames.VDU_ID]?: number;
	[EConfigurationDataFieldNames.DATA_MODEL]?: string;
	[EConfigurationDataFieldNames.PNF_TYPE]?: TMavenirPnfType | string;
	[EConfigurationDataFieldNames.BUILD_VERSION]?: string;
	[EConfigurationDataFieldNames.ELEMENT_TYPE]?: TMavenirElementType | string;
	[EConfigurationDataFieldNames.GROUP_BY]?: TMavenirGroupBy | string;
	[EConfigurationDataFieldNames.PRODUCT_NAME]?: string;
	[EConfigurationDataFieldNames.NS_ID]?: number;
	[EConfigurationDataFieldNames.NS_VERSION]?: string;
	[EConfigurationDataFieldNames.NF_TYPE]?: number;
	[EConfigurationDataFieldNames.COMPONENT_TYPE]?: number;
	[EConfigurationDataFieldNames.COMPONENT_VERSION]?: string;
}
